/**
 * Map all the icon css names from fontello.com
 *
 * @see https://fontello.com/
 */
export const iconNames = {
  PENCIL: 'pencil-alt',
  HOME: 'home',
  CHECK_EMPTY: 'check-empty',
  CHECK_OK: 'check-ok',
  CHECK: 'check',
  PLUS: 'plus',
  MINUS: 'minus',
  UPLOAD: 'upload',
  DOWNLOAD: 'download',
  FLAG_START: 'flag-empty',
  FLAG_END: 'flag',
  CANCEL: 'cancel',
  CIRCLE_CANCEL: 'cancel-circled',
  OK: 'ok',
  ABOUT: 'info',
  INTERACTION: 'arrows-ccw',
  CLOCK: 'clock',
  PUZZLE: 'puzzle-outline',
  FUNCTION: 'function',
  OPERATIONAL: 'calc',
  TARGET: 'target',
  CONDITION: 'condition',
  ASSIGN: 'assign',
  MOVEMENT: 'movement',
  CUSTOM: 'wrench',
  VISION_SIMULATION: 'visionsimulator',
  SIMULATION: 'simulator',
  LAUNCH: 'rocket',
  EXCEL: 'excel',
  WARNING: 'warning',
  BPMN: 'bpmn',

  // -- attributes
  GLOBALS: 'cog-alt',
  RESOURCE: 'cog-outline',
  PRODUCT: 'package',
  VARIABLE: 'chart-line',
  LOCATION: 'map-o',
  WEATHER_DATA: 'fog-sun',
  PARAMETER: 'params',
  DNV: 'dnv'
}
